import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-643a6f34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notfound-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Go see an eye doctor cause u keep texting the WRONG URL !!!!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small-word" }, " FYI: If you can see this line, your eyes are fine, you are just dumb. ", -1))

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const randomPic = computed(() => {
  const picArr = [
    "https://giphy.com/embed/dsWOUTBz5aae8ET8Ss",
    "https://giphy.com/embed/de9SqBlr1ViwvGwzWp",
    "https://giphy.com/embed/Pgy4Na8aRyBuE",
    "https://giphy.com/embed/wUTUBrRYwxMVW",
    "https://giphy.com/embed/iFU36VwXUd2O43gdcr",
  ];
  return picArr[Math.floor(Math.random() * picArr.length)];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      src: _unref(randomPic),
      width: "480",
      height: "480",
      style: {"border":"0"},
      class: "giphy-embed",
      allowFullScreen: ""
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _hoisted_4
  ]))
}
}

})